import React from 'react';
import './inbox-empty.scss';

interface InboxEmptyProps {
  message: string;
}

const InboxEmpty = ({ message }: InboxEmptyProps) => {
  return (
    <div className="inbox-empty">
      <div>{message}</div>
    </div>
  );
};

export default InboxEmpty;